import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import React from "react";
import {HighlightOff} from "@mui/icons-material";
import { DialogHeader } from "../../theme";

function GenericDialog(props) {
    const {open, setOpen, error} = props;
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason === 'backdropClick') setOpen(false);
            }}
        >
            <div style={{
                height: "10px",
                width: "100%",
                background: error || false ? theme.palette.error.main : "#22b36e",
                transition: "background 0.5s ease"
            }}/>
            <DialogTitle style={{
                padding: "8px 12px"
            }}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item container style={{flex: 1, flexDirection: "column"}}>
                        <DialogHeader>
                            {props.title}
                        </DialogHeader>
                    </Grid>

                    <IconButton onClick={() => setOpen(false)} size="large">
                        <HighlightOff style={{color: "red"}}/>
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent style={{padding: "0 12px 12px 12px"}}>
                <Grid container>
                    <Typography>
                        {props.message}
                    </Typography>
                </Grid>
            </DialogContent>
            {props.actions && (
                <DialogActions style={{padding: "0 12px 12px 12px"}}>
                    <Grid container justifyContent={"flex-end"}>
                        {props.actions}
                    </Grid>
                </DialogActions>
            )}
        </Dialog>
    );
}

export default GenericDialog;
